import { useEffect, useState } from "react";

/**
 * Cria uma url local para o arquivo de imagem recém escolhido em um input, para
 * exibir a imagem antes do upload acontecer. A url é revogada quando o arquivo
 * muda ou o componente desmonta.
 */
export default function useImageObjectUrl(file) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!file || !file.type?.startsWith("image/")) {
      setUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return url;
}
